import { collection, onSnapshot } from "firebase/firestore";
import { database } from "../Services/firebase";
import { setErrorStatus } from "../Redux/status/action";
import { useEffect, useRef } from "react";
import { procedureTableField } from "../Utils/Constants/Procedures";
import { putProceduresData } from "../Redux/procedures/action";

export function useProcedures({ isAuth, filterData, sort }) {
  const proceduresListener = useRef(null);
  const procedures = useRef(null);

  const sortProcedures = (data, sortConfig) => {
    return data?.sort((a, b) => {
      let fieldA, fieldB;

      switch (sortConfig?.title) {
        default:
          fieldA = a?.[procedureTableField(sortConfig?.title)];
          fieldB = b?.[procedureTableField(sortConfig?.title)];
          break;
      }

      const stringA = String(fieldA).toLowerCase();
      const stringB = String(fieldB).toLowerCase();
      if (stringA < stringB) {
        return sortConfig.ascending ? -1 : 1;
      }
      if (stringA > stringB) {
        return sortConfig.ascending ? 1 : -1;
      }

      return 0;
    });
  };

  const filterProcedure = (filterData, procedures) => {
    if (!procedures) {
      return [];
    }
    return Object.values(procedures).filter((item) => {
      for (const key in filterData) {
        if (key === "dateRange") {
          const { from, to, type } = filterData[key];
          const createdAt = new Date(item.createdAt);

          if (type === "Lifetime") {
            continue;
          }

          if (type === "Last 30 days") {
            const last30Days = new Date();
            last30Days.setDate(last30Days.getDate() - 30);
            if (createdAt < last30Days) return false;
          }

          if (type === "Last 60 days") {
            const last60Days = new Date();
            last60Days.setDate(last60Days.getDate() - 60);
            if (createdAt < last60Days) return false;
          }

          if (type === "Select Date") {
            const fromDate = new Date(from);
            fromDate.setHours(0, 0, 0, 0);
            const toDate = new Date(to);
            toDate.setHours(23, 59, 59, 999);
            if (createdAt < fromDate || createdAt > toDate) return false;
          }
        } else if (key === "type") {
          if (
            filterData?.type?.length > 0 &&
            !filterData?.type
              ?.map((type) => type.toLowerCase())
              .includes(item.procedureType.toLowerCase())
          ) {
            return false;
          }
        }
      }
      return true;
    });
  };

  function setProcedures() {
    const filteredData = filterProcedure(filterData, procedures.current);
    const sortedData = sortProcedures(filteredData, sort);
    let proceduresData = {};
    sortedData?.forEach((data) => {
      proceduresData = { ...proceduresData, [data.documentId]: data };
    });

    putProceduresData(proceduresData);
  }

  useEffect(() => {
    setProcedures();

    // eslint-disable-next-line
  }, [filterData, sort]);

  const subscribeToProcedures = () => {
    const collectionRef = collection(database, "procedures");

    return onSnapshot(
      collectionRef,
      (dataSnapshot) => {
        let proceduresData = {};
        dataSnapshot.forEach((doc) => {
          proceduresData[doc.id] = {
            ...doc.data(),
            documentId: doc.id
          };
        });
        procedures.current = proceduresData;
        setProcedures();
      },
      (error) => {
        console.error(error, "from procedure listener");
        setErrorStatus(error);
      }
    );
  };

  useEffect(() => {
    if (isAuth === true && proceduresListener.current === null) {
      proceduresListener.current = subscribeToProcedures();
    } else if (
      isAuth === false &&
      typeof proceduresListener.current === "function"
    ) {
      proceduresListener.current();
      proceduresListener.current = null;
    }
    // eslint-disable-next-line
  }, [isAuth]);
}
